import { Routes, Route } from "react-router-dom";

import Login from "../pages/Connexion/Login";
import SessionDisconnect from "../components/authentification/SessionDisconnect";
import UserAccountLinker from "../components/InviteUserAfterMail/UserAccountLinker";
import ResetPassword from "../components/authentification/ResetPassword";
import Erreur404 from "../pages/Erreur404";

const PublicRouter = ({ setRememberMe, isLoggedIn }) => {
 
  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
     
            <Login setRememberMe={setRememberMe} isLoggedIn={isLoggedIn} />
          </>
        }
      />
      <Route
        path="/sessionDisconnect"
        element={
          <>
     
            <SessionDisconnect />
          </>
        }
      />
      <Route
        path="/userAccountLinker"
        element={
          <>
          
            <UserAccountLinker />
          </>
        }
      />
      <Route
        path="/resetPassword/*"
        element={
          <>
          
            <ResetPassword />
          </>
        }
      />
      <Route
        path="*"
        element={
          <>
      
            <Erreur404 />
          </>
        }
      />
    </Routes>
  );
};

export default PublicRouter;
